import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-54">
      <div className="max-w-4xl mx-auto" data-id="element-55">
        <p className="mb-4" data-id="element-56">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="mb-6" data-id="element-57">
          Los resultados pueden variar de persona a persona. Todos los
          testimonios son reales de clientas que han utilizado nuestro sistema.
        </p>
        <div className="flex justify-center space-x-6" data-id="element-58">
          <a href="#" className="hover:text-white transition-colors" data-id="element-59">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-60">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-61">
            Contacto
          </a>
        </div>
        <p className="mt-8" data-id="element-62">
          &copy; {new Date().getFullYear()} Sistema Clínica de Uñas Premium.
          Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}